import software from '../../../assets/img/software.svg';
import hexatech from '../../../assets/img/hexatech.svg';
import metrics from '../../../assets/img/metrics.svg';
import tripletech from '../../../assets/img/tripletech.svg';

export const skillOneTitle = `Cloud Platforms`;
export const skillOneDescription = `
Expertise in AWS, Google Cloud Platform (GCP), and Microsoft Azure. 
We design and deploy scalable cloud infrastructure tailored to your needs.
 `;

export const skillTwoTitle = `DevOps Tools`;
export const skillTwoDescription = `
Kubernetes, Docker, Terraform, Ansible, GitLab CI, GitHub Actions, Jenkins. 
We automate your infrastructure and deployment pipelines for efficiency.
`;

export const skillThreeTitle = `Certified Professionals`;
export const skillThreeDescription = `
AWS and GCP certified team with hands-on experience. We stay current with 
best practices and emerging technologies in the DevOps ecosystem.
 `;

export const numOfCompanies = ` 50 + `;

export const companyData = [
  { imageSrc: software, imageAlt: 'Software Company' },
  { imageSrc: hexatech, imageAlt: 'Hexatech Company' },
  { imageSrc: metrics, imageAlt: 'Metrics Company' },
  { imageSrc: tripletech, imageAlt: 'Tripletech Company' },
];
